const initialState = {
  customers: [],
  editCustomerLoading: false,
  lastInvoiceDates: {},
}

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `SET_CUSTOMERS`:
      return {
        ...state,
        customers: action.data,
      }
    case `SET_EDIT_CUSTOMER_LOADING`:
      return {
        ...state,
        editCustomerLoading: action.data,
      }
    case `SET_LAST_INVOICE_DATES`:
      return {
        ...state,
        lastInvoiceDates: action.data,
      }
    default:
      return state
  }
}

export default customerReducer
